import { Component, OnInit,ViewChild,ElementRef,HostListener,Renderer2 } from '@angular/core';
import { SidePanelService } from '../services/side-pannel/side-pannel.service';
import { Router } from '@angular/router';
import { HomeService } from '../services/home.service';
import { PerformanceTrackerService } from '../services/performance-tracker.service';
import { MatDialog } from '@angular/material/dialog';
import { LogoutConfirmationComponent } from 'src/app/logout-confirmation/logout-confirmation.component';


@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit {

  public isReportExpand:boolean = false;
  public studyId:any;
  public access:any
  public isSuperUser:boolean = false;
  public visibleMenuContainer = [];
  public visibleSideDrawerMenu:any[];
  public embedSideDrawerMenu:any[];
  public isMoreMenueExpand:boolean = false;
  public currentNavigationRoute:boolean
  public dashboardSubMenuActive = [
    '/home/performance-tracker',
    '/home/panel-list',
    '/home/projects/dashboard',
    '/home/visibility',
    '/home/research-survey',
    '/home/survey',
    '/home/bi-report',
    '/home/utm-report',
    '/home/term-report',
    '/home/funnel-report'
  ];

  @ViewChild('MoreMenu') MoreMenu!:ElementRef;
  @ViewChild('MenuButton') MenuButton!:ElementRef;

  constructor(
    public sidePanelService:SidePanelService,
    public router:Router,
    public homeService:HomeService,
    public performTrackerService:PerformanceTrackerService,
    private renderer: Renderer2,
    public dialog: MatDialog,
    ) {}

  ngOnInit(): void {
   
    // console.log("sidePanelService.sideDrawer.mainMenu ===> ",this.sidePanelService.sideDrawer.mainMenu)
    // this.access = JSON.parse(localStorage.getItem('access'));
    // if(this.access && this.access.super){
    //   this.isSuperUser = true;
    // }
    // const currentUrl = this.router.url;
    // let url = currentUrl.split('/');
    // this.studyId = url[url.length-1];
    // this.performTrackerService.getStudyVisibility(this.studyId).subscribe((data) =>{
    //   if(data.data){
    //     // if(data.data && data.data.survey){
    //     //   this.homeService.showSurveyBuilder = data.data.survey.show ? true : false;
    //     // }
    //     if(data.data && data.data['funnel-Report']){
    //       this.homeService.isFunnelReport = data.data['funnel-Report'].show ? true : false;
    //     }
    //     if(data.data && data.data['term-Report']){
    //       this.homeService.isTermReport = data.data['term-Report'].show ? true : false;
    //     }
    //     if(data.data && data.data['utm-Report']){
    //       this.homeService.isUtmReport = data.data['utm-Report'].show ? true : false;
    //     }
    //   }else{
    //     // this.homeService.showSurveyBuilder = false;
    //     // this.homeService.isExternalReportCheck = false;
    //     // this.homeService.isFunnelReport = false;
    //     // this.homeService.isUtmReport = false;
    //     // this.homeService.isTermReport = false;
    //   }
    // })
    // this.performTrackerService.getStudyVisibility();
    // console.log("sidePanelService.sideDrawer.mainMenu ===> ",this.sidePanelService.sideDrawer.mainMenu);
    // console.log("sidePanelService.sideDrawer.mainMenu ===> ",this.sidePanelService.sideDrawer.mainMenu)
    // console.log("sidePanelService.sideDrawer.mainMenu ===> ",this.sidePanelService.sideDrawer.mainMenu);
    // let length = this.sidePanelService.sideDrawer.mainMenu.
    // console.log("sidePanelService.sideDrawer.mainMenu ===> ",this.sidePanelService.sideDrawer.mainMenu);
    // let path = this.router.url;
    // console.log("path ===> ",path);
    let mainMenu = this.sidePanelService.sideDrawer.mainMenu.filter((menu) => menu.name !== 'More');
    if(mainMenu.length <= 4){
      this.visibleSideDrawerMenu = mainMenu
      this.embedSideDrawerMenu = [];
    }else{
      this.visibleMenuContainer = this.sidePanelService.sideDrawer.mainMenu.slice(0,4).map((menu) => {
        return menu.name;
      });
      this.visibleMenuContainer.push('More');
      this.visibleSideDrawerMenu = this.sidePanelService.sideDrawer.mainMenu.filter((menu) =>  this.visibleMenuContainer.includes(menu.name));
      this.embedSideDrawerMenu = this.sidePanelService.sideDrawer.mainMenu.filter((menu) => !this.visibleMenuContainer.includes(menu.name));
      // this.embedSideDrawerMenu = [...this.embedSideDrawerMenu.splice(0,3)];
    }
   
    // this.visibleSideDrawerMenu = this.sidePanelService.sideDrawer.mainMenu.filter((menu) =>  this.visibleMenuContainer.includes(menu.name));
    // this.embedSideDrawerMenu = this.sidePanelService.sideDrawer.mainMenu.filter((menu) => !this.visibleMenuContainer.includes(menu.name));
    // console.log("visibleSideDrawerMenu ===> ",this.visibleSideDrawerMenu);

  }


  navigetToReports(type){
    if(type == 'funnel'){
      this.router.navigateByUrl(`home/funnel-report/${this.studyId}`);
    }
    else if(type === 'term'){
      this.router.navigateByUrl(`home/term-report/${this.studyId}`);
    }
    else{
      this.router.navigateByUrl(`home/utm-report/${this.studyId}`);
    }


  }


  externalReportToggle(){
    this.isReportExpand = !this.isReportExpand;
  }

  toggleMoreMenu(){
    this.isMoreMenueExpand = !this.isMoreMenueExpand;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    if (
      this.isMoreMenueExpand &&
      this.MoreMenu?.nativeElement &&
      this.MenuButton?.nativeElement
    ) {
      const clickedInside = this.MoreMenu.nativeElement.contains(event.target);
      const clickedMenuButton = this.MenuButton.nativeElement.contains(event.target);
      if (!clickedInside && !clickedMenuButton) {
        this.isMoreMenueExpand = false;
      }
    }
  }

  navigateMenu(menu){
    if(menu.name === 'More'){
      this.toggleMoreMenu();
    }else{
      this.sidePanelService.navigateMenu(menu.route)
    }
     
  }

  checkforEmbedMenuActive(){
    let mainRoute = this.router.url.split('?')[0];
    mainRoute = mainRoute.split('/')[1];
    let val = this.embedSideDrawerMenu.some(
      (
        menu => menu.route ===  this.router.url || 
        mainRoute && mainRoute != 'repo' && menu.route.includes(mainRoute)
      ));
    return val 
  }

  checkforDashboardSubMenuActive(){
    const currentUrl = this.router.url;
    return this.dashboardSubMenuActive.some(route => currentUrl.startsWith(route));
  }

  checkforEmbedMenuPageActive(menu){
    let val = this.embedSideDrawerMenu.find((m) => m.route == menu.route);
    return val ? true : false;
  }

  logoutPopUpConfirmation():void{
    this.dialog.open(LogoutConfirmationComponent, {});
  }

  


  


  


  

}
